











































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPopover,
  },
  computed: mapState("schedule", ["calendars"]),
})
export default class ProviderFilter extends Vue {
  id = "provider-filter-popover";
  target = "provider-filter-target";
  calendars!: Array<any>;
  list = Array<any>();

  async checkProvider() {
    this.list.forEach((ss) => {
      ss.checked = true;
    });
  }
  async uncheckProvider() {
    this.list.forEach((ss) => {
      ss.checked = false;
    });
  }
  
  get checkedProviders(): Array<any> {
    return this.list
      .filter((ss) => {
        return ss.checked;
      })
      .map((ss) => ss.id);
  }
 
  search() {
    var filter = JSON.parse(JSON.stringify(this.checkedProviders));
    this.$store.commit("gaps/SET_REPORT_PROVIDERS_FILTER", filter);
    this.close();
  }
  clear() {
    this.uncheckProvider();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { insurerList } = this.$store.state.gaps.filter.report;
    this.list = JSON.parse(JSON.stringify(this.calendars)).map((ss) => {
      ss.checked = insurerList.includes(ss.id);
      return ss;
    });
  }
}
